<div class="d-flex align-items-center">
  <a class="btn btn-light btn-sm mx-1" [href]="facebook" target="blank">
    <i class="fab fa-facebook"></i>
  </a>
  <a class="btn btn-light btn-sm mx-1" [href]="twitter" target="blank">
    <i class="remixicon-twitter-x-fill"></i>
  </a>
  <a class="btn btn-light btn-sm mx-1" [href]="linkedin" target="blank">
    <i class="fab fa-linkedin"></i>
  </a>
  <a class="btn btn-light btn-sm mx-1" [href]="email" target="blank">
    <i class="fa fa-envelope"></i>
  </a>
</div>
